import { ApiKeys } from '@app/constants/api-keys'
import { IOrganizationLocality } from '@app/interfaces/organization/organization-locality'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from '../../types'

export const organizationLocalityApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getOrganizationLocalities: build.query<
      IRtkResponse<IOrganizationLocality[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/organization-locality',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IOrganizationLocality[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.organizationLocality,
                id,
              })),
              { type: ApiKeys.organizationLocality, id: 'LIST' },
            ]
          : [{ type: ApiKeys.organizationLocality, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.organizationLocality, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getOrganizationLocality: build.query<IOrganizationLocality, number>({
      query: (id) => ({
        url: `dictionary/api/v1/organization-locality/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.organizationLocality, id },
      ],
    }),
  }),
})

export const {
  useGetOrganizationLocalitiesQuery,
  useGetOrganizationLocalityQuery,
} = organizationLocalityApi
